export default "__VITE_ASSET__oEY_UaVQ__"